<script>
    import { sendAnalytics } from "@/core/SendAnalytics";
    import { myTarget } from "@/core/SendMyTarget";
    import BaseButton from "@main/packages/BaseButton";
    import BaseInput from "@main/packages/BaseInput";
    import StatusOrderProgress from "@/components/StatusOrderProgress";
    import StatusOrderItem from "@/components/StatusOrderItem";

    export default {
        name: "StatusOrder",
        components: {
            StatusOrderItem,
            StatusOrderProgress,
            BaseButton,
            BaseInput,
        },
        props: {
            statusOrderId: String,
        },
        data() {
            return {
                order: this.statusOrderId || "",
                phone: "",
                loading: Boolean(this.statusOrderId),
                errorText: {
                    order: "",
                    phone: "",
                },
                type: "order",
                orders: [],
                orderProgress: "",
                activeIndexes: [0],
            };
        },
        mounted() {
            this.$refs.orderInput.$el.focus();
            if (this.statusOrderId) {
                this.submit();
            }
        },
        methods: {
            resetOrder() {
                this.order = "";
                this.phone = "";
                this.orders = [];
            },
            submit() {
                this.setErrorText();
                if (this.order.length > 1 || this.phone.length > 3) {
                    this.resetErrorText();
                    this.loading = true;

                    this.$store.rootApi
                        .getStatusOrder({ orderId: this.order, phone: this.phone })
                        .then((response) => {
                            this.loading = false;
                            if (response.error) {
                                const key = !this.order ? "phone" : "order";
                                this.errorText[key] = "Заказ с таким номером не найден";
                                return false;
                            } else {
                                response.orders.length
                                    ? (this.orders = response.orders)
                                    : (this.errorText.phone =
                                          "По вашему номеру заказов не найдено");
                                this.orders = response.orders;
                                this.orderProgress = this.orders[0]?.progress;
                            }
                            sendAnalytics.send(sendAnalytics.events.orderStatus);
                            myTarget.reachGoal("order-status");
                        });
                }
            },
            onChangeType() {
                this.resetErrorText();
                this.resetOrder();
            },
            resetErrorText() {
                this.errorText.order = "";
                this.errorText.phone = "";
            },
            setErrorText() {
                this.errorText.order = "Необходимо ввести номер заказа";
                this.errorText.phone = "Необходимо ввести номер телефона";
            },
            toggleActiveOrder(index) {
                if (this.activeIndexes.includes(index)) {
                    const removedIndex = this.activeIndexes.indexOf(index);
                    this.activeIndexes.splice(removedIndex, 1);

                    if (this.activeIndexes.length) {
                        this.orderProgress =
                            this.orders[
                                this.activeIndexes[this.activeIndexes.length - 1]
                            ].progress;
                    } else {
                        this.orderProgress = "";
                    }
                } else {
                    this.activeIndexes.push(index);
                    this.orderProgress = this.orders[index].progress;
                }
            },
        },
    };
</script>

<template>
    <div class="status-order">
        <status-order-progress
            v-if="orders.length"
            :progress="orderProgress"
            @reset-order="resetOrder"
        ></status-order-progress>

        <template v-if="orders.length">
            <status-order-item
                v-for="(order, index) in orders"
                :key="order.number"
                :order="order"
                :index="index"
                :is-opened="activeIndexes.includes(index)"
                @on-set-active-order="toggleActiveOrder"
            ></status-order-item>

            <base-button
                class="status-order-other"
                :size="$root.$_size_modal_button || 'lg'"
                :variant="$root.$_variant_outline_button || 'v2'"
                @click="resetOrder"
            >
                Статус другого заказа
            </base-button>
        </template>

        <div v-else class="status-order-modal">
            <form class="status-order-modal__form" @submit.prevent="submit">
                <div class="status-order-modal__tabs">
                    <label class="status-order-modal__label">
                        <input
                            class="status-order-modal__input visually-hidden"
                            type="radio"
                            name="type"
                            value="order"
                            v-model="type"
                            @change="onChangeType"
                        />
                        <span class="status-order-modal__radio"></span>
                        <span class="status-order-modal__label-text">Номер заказа</span>
                    </label>

                    <label class="status-order-modal__label">
                        <input
                            class="status-order-modal__input"
                            type="radio"
                            name="type"
                            value="phone"
                            v-model="type"
                            @change="onChangeType"
                        />
                        <span class="status-order-modal__radio"></span>
                        <span class="status-order-modal__label-text">Номер телефона</span>
                    </label>
                </div>

                <base-input
                    v-if="type === 'order'"
                    v-model="order"
                    name="order"
                    type="text"
                    placeholder="Введите номер заказа"
                    :error-text="errorText.order"
                    key="order"
                    @error="resetErrorText"
                    ref="orderInput"
                ></base-input>

                <base-input
                    v-if="type === 'phone'"
                    v-model="phone"
                    name="phone"
                    type="tel"
                    placeholder="Введите номер телефона"
                    :error-text="errorText.phone"
                    key="phone"
                    @error="resetErrorText"
                ></base-input>
            </form>

            <div class="status-order-modal__control">
                <base-button
                    :variant="$root.$_variant_modal_button || 'v1'"
                    :size="$root.$_size_modal_button || 'lg'"
                    :is-loading="loading"
                    @click="submit"
                >
                    Узнать статус заказа
                </base-button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .status-order-other {
        width: 100%;
    }

    .status-order-modal {
        text-align: center;
    }

    .status-order-modal__form {
        margin-bottom: 16px;
    }

    .status-order-modal__control {
        display: flex;
        justify-content: center;

        button {
            width: 100%;
        }
    }

    .status-order-modal__tabs {
        display: flex;
        align-items: center;
    }

    .status-order-modal__label {
        display: flex;
        align-items: center;
        padding-right: 10px;
        cursor: pointer;
    }

    .status-order-modal__label-text {
        margin-left: 5px;
        font-size: 12px;
        text-align: left;
        @include bp($bp-desktop-sm) {
            font-size: 14px;
        }
    }

    .status-order-modal__input {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        opacity: 0;
        @include bp($bp-desktop-sm) {
            &:focus-visible {
                & + .status-order-modal__radio {
                    @include outline;
                }
            }
        }
    }

    .status-order-modal__radio {
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 100px;
        border: 3px solid var(--base-white);
        box-shadow: 0 0 0 var(--input-border-width) var(--input-border-color);
        transition: background-color 0.2s ease-in, box-shadow 0.2s ease-in;
    }

    .status-order-modal__input:checked + .status-order-modal__radio {
        background-color: var(--modal-control-fill);
    }
</style>
